export default __webpack_public_path__ + "static/media/cash.7b7ec684.svg";